import {
  BarChart3,
  BookOpen,
  CalendarClock,
  CalendarDays,
  ClipboardList,
  DoorOpen,
  Home,
  LogOut,
  Menu,
  Settings,
  UsersRound,
  X
} from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useAuth } from "../context/AuthContext.jsx";

const adminNav = [
  { to: "/admin/dashboard", label: "Dashboard", icon: Home },
  { to: "/admin/routine-board", label: "Routine Board", icon: CalendarDays },
  { to: "/admin/routines", label: "Routine Manager", icon: CalendarClock },
  { to: "/admin/teachers", label: "Teachers", icon: UsersRound },
  { to: "/admin/subjects", label: "Subjects", icon: BookOpen },
  { to: "/admin/resources", label: "Classes / Sections / Rooms", icon: DoorOpen },
  { to: "/admin/logs", label: "Time Logs", icon: ClipboardList },
  { to: "/admin/reports", label: "Reports", icon: BarChart3 },
  { to: "/admin/settings", label: "Settings", icon: Settings }
];

function AdminSidebar({ onNavigate }) {
  const { logout, user } = useAuth();

  return (
    <aside className="admin-sidebar">
      <div className="brand-row">
        <div className="app-mark">P</div>
        <div>
          <strong>PARIKSIT Time</strong>
          <span>{user?.name || "Admin"}</span>
        </div>
      </div>
      <Link className="btn btn-primary btn-wide" to="/user/home" onClick={onNavigate}>
        Switch to Staff View
      </Link>
      <nav className="side-nav" aria-label="Admin navigation">
        {adminNav.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onNavigate}
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <Icon size={19} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      <button className="btn btn-ghost sidebar-logout" type="button" onClick={logout}>
        <LogOut size={18} />
        Logout
      </button>
    </aside>
  );
}

export default function AdminLayout() {
  const [open, setOpen] = useState(false);

  return (
    <div className="admin-shell">
      <div className="desktop-sidebar">
        <AdminSidebar />
      </div>
      <header className="admin-topbar">
        <button className="icon-button" type="button" onClick={() => setOpen(true)} aria-label="Open menu">
          <Menu size={21} />
        </button>
        <div>
          <p>Admin Panel</p>
          <h1>PARIKSIT Teachers Time Tracker</h1>
        </div>
      </header>
      <AnimatePresence>
        {open ? (
          <motion.div
            className="drawer-layer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="drawer-panel"
              initial={{ x: -300 }}
              animate={{ x: 0 }}
              exit={{ x: -300 }}
              transition={{ duration: 0.2 }}
            >
              <button className="icon-button drawer-close" type="button" onClick={() => setOpen(false)}>
                <X size={20} />
              </button>
              <AdminSidebar onNavigate={() => setOpen(false)} />
            </motion.div>
          </motion.div>
        ) : null}
      </AnimatePresence>
      <main className="content-page admin-content">
        <Outlet />
      </main>
    </div>
  );
}
